// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UpdateArticlesInShopCategoryRequestModel from '../../model/update-articles-in-shop-category-request-model';
import UpdateArticlesInShopCategoryRequestDTO from '../dto/update-articles-in-shop-category-request-dto';
import dtoSchema from '../schemas/update-articles-in-shop-category-request-schema';

export default abstract class UpdateArticlesInShopCategoryRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UpdateArticlesInShopCategoryRequestDTO>) {
    super();
    if (data) {
      this.articleIds = data.articleIds;
      this.id = data.id;
    }
  }
  /**
  */
  articleIds?: number[];
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<UpdateArticlesInShopCategoryRequestDTO>): UpdateArticlesInShopCategoryRequestModel;
  static toModel(dto: DeepPartial<UpdateArticlesInShopCategoryRequestDTO> | undefined | null): UpdateArticlesInShopCategoryRequestModel | undefined;
  static toModel(dto: DeepPartial<UpdateArticlesInShopCategoryRequestDTO> | undefined | null): UpdateArticlesInShopCategoryRequestModel | undefined {
    return dto ? new UpdateArticlesInShopCategoryRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UpdateArticlesInShopCategoryRequestModel> | UpdateArticlesInShopCategoryRequestModel): UpdateArticlesInShopCategoryRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      articleIds: unwrapped.articleIds,
      id: unwrapped.id,
    } as UpdateArticlesInShopCategoryRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UpdateArticlesInShopCategoryRequestModel, can not map to UpdateArticlesInShopCategoryRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
